<template>
<!-- 人员信息 -->
  <div>
    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :total="total"
      :pageSize="pageSize"
      @currentChange="currentChange"
    >
      <el-table-column prop="date" label="#" width="60" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="username" :label="$t('pages.system.text66')" width="180" align="center">
      </el-table-column>
      <el-table-column prop="realName" :label="$t('pages.system.text68')" align="center">
      </el-table-column>
      <el-table-column prop="departmentName" :label="$t('pages.system.text69')" align="center">
      </el-table-column>
      <el-table-column prop="roleName" :label="$t('pages.system.text70')" align="center">
      </el-table-column>
    </DiluTable>
  </div>
</template>

<script>
import DiluTable from "../../../../components/pubilc/dilu-table.vue";
export default {
  data() {
    return {
      tableConfig: {
        isTree: false,
        isTreeText: "id",
        isPage: true,
      },
    };
  },
  props: ["tableData", "total",'pageSize'],
  components: {
    DiluTable,
  },
  methods:{
    //翻页
    currentChange(e){
      this.$emit('currentChange',e)
    }
  }
};
</script>